module.exports = __webpack_public_path__ + "static/media/cmr_8.d8870647.jpg";